// extracted by mini-css-extract-plugin
export default {"container":"KBLTU","active":"WHDpm","logo":"xOPND","name":"UvA9N"};